import React from "react";
import Box from "@mui/material/Box";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useAppContext } from "../../Lib/ContextLib";
import SweetAlert from "react-bootstrap-sweetalert";
import { API_URL } from "../../config";
import Loader from "../Loader/Loader";

export default function Bonus() {
  const { setShowPage, accessObject } = useAppContext();
  const [alert, setAlert] = React.useState(null);
  const [tableData, setTableData] = React.useState();
  const [loader, setLoader] = React.useState(false);
  const [buttonLoader, setbuttonLoader] = React.useState(false);

  React.useEffect(() => {
    getBranch();
  }, []);

  const getBranch = () => {
    setLoader(true);
    axios(`${API_URL}/api/admin/bonus/get-bonus`, {
      method: "GET",
      credentials: "include",
    })
      .then((response) => {
        setLoader(false);

        setTableData(response.data.data);
      })
      .catch((error) => {
        console.log("getBranch error :::", error);
      });
  };

  const LoginSchema3 = Yup.object().shape({
    signUpBonus: Yup.number().required("required"),
    referBonus1: Yup.number().required("required"),
    referBonus2: Yup.number().required("required"),
    referBonus3: Yup.number().required("required"),
    addMoneyBonus: Yup.number().required("required"),
  });

  const successEdit = (msg) => {
    console.log("donw");
    setAlert(
      <SweetAlert
        success
        style={{ display: "block" }}
        title=""
        onConfirm={() => {
          getBranch();
          setAlert(null);
          setShowPage(false);
        }}
        confirmBtnBsStyle="success"
      >
        <h4>{msg}</h4>
      </SweetAlert>
    );
  };

  return (
    <>
      {alert}

      <div class="content p-3 ">
        <div className="card p-3">
          {!loader && (
            <Box sx={{ width: "100%" }}>
              <Formik
                initialValues={{
                  signUpBonus: tableData?.signUpBonus || 0,
                  referBonus1: tableData?.referBonus1 || 0,
                  referBonus2: tableData?.referBonus2 || 0,
                  referBonus3: tableData?.referBonus3 || 0,
                  addMoneyBonus: tableData?.addMoneyBonus || 0,
                }}
                validationSchema={LoginSchema3}
                onSubmit={(values) => {
                  setbuttonLoader(true);
                  let merged = { ...values, id: tableData?._id };
                  console.log("values", values);
                  axios(
                    `${API_URL}/api/admin/bonus/update-bonus/${tableData?._id}`,
                    {
                      method: "PATCH",
                      credentials: "include",
                      data: merged,
                    }
                  )
                    .then((result) => {
                      console.log("handleSubmit result :::", result.data);
                      setbuttonLoader(false);
                      successEdit(result.data.message);
                    })
                    .catch((err) => {
                      console.log("handleSubmit err :::", err);
                    });
                }}
              >
                {({ touched, errors, isSubmitting, values }) => (
                  <div className="p-2">
                    <Form>
                      <div className="row">
                        {/* signUpBonus */}
                        <div className="col-md-6 mb-4">
                          <label className="font-weight-bold text-muted small mb-2">
                            Sign Up Bonus
                          </label>
                          <Field
                            type="number"
                            name="signUpBonus"
                            placeholder="Sign Up Bonus"
                            disabled={!accessObject?.editBonus}
                            className={`form-control ${
                              touched.signUpBonus && errors.signUpBonus ? "is-invalid" : ""
                            }`}
                            style={{
                              borderRadius: "10px",
                              padding: "12px 15px",
                              border: "1px solid #e2e8f0",
                              backgroundColor: "#f8fafc",
                              height: "auto"
                            }}
                          />
                          <ErrorMessage
                            component="div"
                            name="signUpBonus"
                            className="invalid-feedback"
                          />
                        </div>

                        {/* referBonus1 */}
                        <div className="col-md-6 mb-4">
                          <label className="font-weight-bold text-muted small mb-2">
                            Refer Bonus 1
                          </label>
                          <Field
                            type="number"
                            name="referBonus1"
                            placeholder="Refer Bonus 1"
                            disabled={!accessObject?.editBonus}
                            className={`form-control ${
                              touched.referBonus1 && errors.referBonus1 ? "is-invalid" : ""
                            }`}
                            style={{
                              borderRadius: "10px",
                              padding: "12px 15px",
                              border: "1px solid #e2e8f0",
                              backgroundColor: "#f8fafc",
                              height: "auto"
                            }}
                          />
                          <ErrorMessage
                            component="div"
                            name="referBonus1"
                            className="invalid-feedback"
                          />
                        </div>

                        {/* referBonus2 */}
                        <div className="col-md-6 mb-4">
                          <label className="font-weight-bold text-muted small mb-2">
                            Refer Bonus 2
                          </label>
                          <Field
                            type="number"
                            name="referBonus2"
                            placeholder="Refer Bonus 2"
                            disabled={!accessObject?.editBonus}
                            className={`form-control ${
                              touched.referBonus2 && errors.referBonus2 ? "is-invalid" : ""
                            }`}
                            style={{
                              borderRadius: "10px",
                              padding: "12px 15px",
                              border: "1px solid #e2e8f0",
                              backgroundColor: "#f8fafc",
                              height: "auto"
                            }}
                          />
                          <ErrorMessage
                            component="div"
                            name="referBonus2"
                            className="invalid-feedback"
                          />
                        </div>

                        {/* referBonus3 */}
                        <div className="col-md-6 mb-4">
                          <label className="font-weight-bold text-muted small mb-2">
                            Refer Bonus 3
                          </label>
                          <Field
                            type="number"
                            name="referBonus3"
                            placeholder="Refer Bonus 3"
                            disabled={!accessObject?.editBonus}
                            className={`form-control ${
                              touched.referBonus3 && errors.referBonus3 ? "is-invalid" : ""
                            }`}
                            style={{
                              borderRadius: "10px",
                              padding: "12px 15px",
                              border: "1px solid #e2e8f0",
                              backgroundColor: "#f8fafc",
                              height: "auto"
                            }}
                          />
                          <ErrorMessage
                            component="div"
                            name="referBonus3"
                            className="invalid-feedback"
                          />
                        </div>

                        {/* addMoneyBonus */}
                        <div className="col-md-6 mb-4">
                          <label className="font-weight-bold text-muted small mb-2">
                            Add Money Bonus (%)
                          </label>
                          <Field
                            type="number"
                            name="addMoneyBonus"
                            placeholder="Add Money Bonus"
                            disabled={!accessObject?.editBonus}
                            className={`form-control ${
                              touched.addMoneyBonus && errors.addMoneyBonus ? "is-invalid" : ""
                            }`}
                            style={{
                              borderRadius: "10px",
                              padding: "12px 15px",
                              border: "1px solid #e2e8f0",
                              backgroundColor: "#f8fafc",
                              height: "auto"
                            }}
                          />
                          <ErrorMessage
                            component="div"
                            name="addMoneyBonus"
                            className="invalid-feedback"
                          />
                        </div>
                      </div>

                      {accessObject?.editBonus == true && (
                        <div className="mt-2">
                          <button
                            type="submit"
                            className="btn btn-warning font-weight-bold px-4"
                            disabled={buttonLoader}
                            style={{
                              borderRadius: "8px",
                              border: "none",
                              height: "45px",
                              boxShadow: "0 4px 6px -1px rgba(255, 193, 7, 0.2)",
                              color: "#000"
                            }}
                          >
                            <div className="d-flex align-items-center justify-content-center">
                              <span>Submit</span>
                              {buttonLoader && (
                                <div
                                  className="spinner-border spinner-border-sm ml-2"
                                  role="status"
                                ></div>
                              )}
                            </div>
                          </button>
                        </div>
                      )}
                    </Form>
                  </div>
                )}
              </Formik>
            </Box>
          )}
          {loader && <Loader />}
        </div>
      </div>
    </>
  );
}
